import * as Yup from "yup";

const nfSaidaReferenciaValidator = () =>
  Yup.array()
    .of(
      Yup.object().shape({
        nfSaidaReferenciaId: Yup.number()
          .nullable()
          .required("NF Saida Referencia ID"),
        chaveDocumentoReferencia: Yup.string()
          .nullable()
          .required("Chave do documento de referência"),
        tipoDocumento: Yup.string().nullable().required("Tipo de documento"),
      }),
    )
    .nullable();

export default nfSaidaReferenciaValidator;
